var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 120,
    viewBox: "0 0 285 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_15166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40H60V116C60 118.209 58.2091 120 56 120H4C1.79086 120 0 118.209 0 116V40Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H56C58.2091 0 60 1.79086 60 4V40H0V4Z",
    fill: "#4B2CE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 73.2812V83.9688H26.5625V82.7344H23.7969V81.5156H26.5625V73.2812H28.3125ZM16.4062 79.625C19.0078 79.6094 22.5156 79.5859 25.5156 79.2031L25.6094 80.4531C24.4453 80.6484 23.2422 80.7734 22.0469 80.8594V83.5781H20.3125V80.9531C18.9922 81.0078 17.7344 81.0156 16.625 81.0156L16.4062 79.625ZM17.4844 76.2969C17.4844 74.8047 18.9219 73.7891 21.0156 73.7969C23.0703 73.7891 24.5156 74.8047 24.5312 76.2969C24.5156 77.8125 23.0703 78.7734 21.0156 78.7812C18.9219 78.7734 17.4844 77.8125 17.4844 76.2969ZM18.2812 87.1094V82.9375H20.0156V85.7031H28.6406V87.1094H18.2812ZM19.125 76.2969C19.125 77.0625 19.8828 77.5078 21.0156 77.5156C22.0938 77.5078 22.8672 77.0625 22.875 76.2969C22.8672 75.5312 22.0938 75.0703 21.0156 75.0781C19.8828 75.0703 19.125 75.5312 19.125 76.2969ZM41.625 73.9531V75.0469C41.6328 76.1484 41.6328 77.3984 41.2812 79.0625H43.2031V80.4688H30.2969V79.0625H39.5234C39.8594 77.5312 39.8906 76.375 39.8906 75.3438H31.8906V73.9531H41.625ZM31.8438 87.2188V82.1094H41.6094V87.2188H31.8438ZM33.5469 85.8125H39.8906V83.4688H33.5469V85.8125Z",
    fill: "#4B2CE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 12.2656V26.4062H26.4688V12.2656H28.2188ZM16.9219 18.2812C16.9141 15.2344 18.4688 13.2969 20.6094 13.2969C22.7266 13.2969 24.2891 15.2344 24.2969 18.2812C24.2891 21.3516 22.7266 23.2812 20.6094 23.2812C18.4688 23.2812 16.9141 21.3516 16.9219 18.2812ZM18.5938 18.2812C18.5938 20.4531 19.4141 21.7109 20.6094 21.7188C21.7969 21.7109 22.6094 20.4531 22.6094 18.2812C22.6094 16.125 21.7969 14.8594 20.6094 14.8594C19.4141 14.8594 18.5938 16.125 18.5938 18.2812ZM35.3594 16.2812C35.3516 18.4609 36.6641 20.9453 38.8906 21.9844L37.9219 23.3594C36.3281 22.6094 35.1484 21.0938 34.5156 19.3281C33.875 21.2656 32.6406 22.9219 31.0156 23.7031L30 22.3438C32.25 21.2734 33.6172 18.6328 33.625 16.2812V15.0938H30.5469V13.6562H38.3125V15.0938H35.3594V16.2812ZM39.625 26.3906V12.2656H41.3594V17.7656H43.5312V19.2188H41.3594V26.3906H39.625Z",
    fill: "#E0E7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_316_15166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 110,
    transform: "translate(75 10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 40H135V116C135 118.209 133.209 120 131 120H79C76.7909 120 75 118.209 75 116V40Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 14C75 11.7909 76.7909 10 79 10H131C133.209 10 135 11.7909 135 14V40H75V14Z",
    fill: "#4B2CE8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_316_15166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 100,
    transform: "translate(150 20)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 40H210V116C210 118.209 208.209 120 206 120H154C151.791 120 150 118.209 150 116V40Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 24C150 21.7909 151.791 20 154 20H206C208.209 20 210 21.7909 210 24V40H150V24Z",
    fill: "#4B2CE8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_316_15166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 90,
    transform: "translate(225 30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 40H285V116C285 118.209 283.209 120 281 120H229C226.791 120 225 118.209 225 116V40Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 34C225 31.7909 226.791 30 229 30H281C283.209 30 285 31.7909 285 34V40H225V34Z",
    fill: "#4B2CE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_15166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_316_15166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 110,
    fill: "white",
    transform: "translate(75 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_316_15166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 100,
    fill: "white",
    transform: "translate(150 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_316_15166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 90,
    fill: "white",
    transform: "translate(225 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstant);
export default __webpack_public_path__ + "static/media/constant.63d0e2b5b4b9c0b118b39825589af176.svg";
export { ForwardRef as ReactComponent };